import script from "./FList.vue?vue&type=script&setup=true&lang=js"
export * from "./FList.vue?vue&type=script&setup=true&lang=js"

import "./FList.vue?vue&type=style&index=0&id=52141a3f&scoped=true&lang=css"

import exportComponent from "D:\\nodejs\\wys02\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52141a3f"]])

export default __exports__